
import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from './Modal';

export default function AddToWishlistModal({ 
  showModal, 
  onClose, 
  userWishlists, 
  onAddToWishlist 
}) {
  const { t } = useTranslation();

  return (
    <Modal
      title={t('addProductModal.chooseWishlist')}
      showModal={showModal}
      onClose={onClose}
      customContent={true}
    >
      <div style={styles.chooseWishlistModal}>
        <div style={styles.chooseWishlistHeader}>
          <h3 style={styles.chooseWishlistTitle}>{t('addProductModal.chooseWishlist')}</h3>
        </div>
        <div style={styles.chooseWishlistContent}>
          {userWishlists.map(w => (
            <button
              key={w.id}
              style={styles.chooseWishlistBtn}
              onClick={() => onAddToWishlist(w.id)}
            >
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                <span style={{ textAlign: "center" }}>{w.name}</span>
                {!w.isOwner && (
                  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2">
                    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
                    <circle cx="9" cy="7" r="4"/>
                    <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                  </svg>
                )}
              </div>
            </button>
          ))}
          <button style={styles.chooseWishlistCancel} onClick={onClose}>
            {t('common.cancel')}
          </button>
        </div>
      </div>
    </Modal>
  );
}

const styles = {
  chooseWishlistModal: {
    background: "#fff",
    borderRadius: "12px",
    width: "100%",
    maxWidth: "350px",
    boxShadow: "0 8px 32px rgba(0,0,0,0.3)",
    overflow: "hidden",
    margin: "auto"
  },
  chooseWishlistHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 20px 12px 20px",
    borderBottom: "1px solid #eee"
  },
  chooseWishlistTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#000",
    margin: 0
  },
  chooseWishlistContent: {
    padding: "16px 20px 20px 20px",
    maxHeight: "60vh",
    overflowY: "auto",
    overflowX: "hidden"
  },
  chooseWishlistBtn: {
    width: "100%",
    padding: "12px 16px",
    margin: "0 0 8px 0",
    background: "#000",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    textAlign: "center",
    boxSizing: "border-box"
  },
  chooseWishlistCancel: {
    width: "100%",
    padding: "12px 16px",
    margin: "8px 0 0 0",
    background: "#f5f5f5",
    color: "#000",
    border: "none",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    textAlign: "center",
    boxSizing: "border-box"
  }
};
